export const consent = () => ({
  C0001: window.OptanonActiveGroups?.includes('C0001') || true,
  C0002: window.OptanonActiveGroups?.includes('C0002') || false,
  C0003: window.OptanonActiveGroups?.includes('C0003') || false,
  C0004: window.OptanonActiveGroups?.includes('C0004') || false,
});
